import { useRef, useState } from 'react';

export default function useThumbnailDrop(onFiles, disabled = false) {
  const depth = useRef(0);
  const [dragging, setDragging] = useState(false);
  const isFileDrag = (event) =>
    Array.from(event.dataTransfer.types).includes('Files');
  return {
    dragging,
    dropProps: {
      onDragEnter(event) {
        if (!isFileDrag(event)) return;
        event.preventDefault();
        event.stopPropagation();
        depth.current += 1;
        if (!disabled) setDragging(true);
      },
      onDragOver(event) {
        if (!isFileDrag(event)) return;
        event.preventDefault();
        event.stopPropagation();
        event.dataTransfer.dropEffect = disabled ? 'none' : 'copy';
      },
      onDragLeave(event) {
        if (!isFileDrag(event)) return;
        event.preventDefault();
        event.stopPropagation();
        depth.current = Math.max(0, depth.current - 1);
        if (!depth.current) setDragging(false);
      },
      onDrop(event) {
        if (!isFileDrag(event)) return;
        event.preventDefault();
        event.stopPropagation();
        depth.current = 0;
        setDragging(false);
        if (!disabled) onFiles(Array.from(event.dataTransfer.files));
      },
    },
  };
}
